<template>
  <div class="orders">
    <van-nav-bar :title="lang.Orders" :left-arrow="!$route.query.fromapp" @click-left="onClickLeft" />
    <div class="filtter-box" :class="{ 'list-tab-fixed': fixedFlag }">
      <div :class="{ filtterItem: true, checkedRed: hasClassifyType }" @click.stop="poputShow(1)">
        {{ lang.AllTypes }}
        <div :class="{ h: true, checkedBgRed: hasClassifyType }"></div>
      </div>
      <div :class="{ filtterItem: true, checkedRed: hasPayStyleType }" @click.stop="poputShow(2)">
        {{ lang.PaymentMethod }}
        <div :class="{ h: true, checkedBgRed: hasPayStyleType }"></div>
      </div>
      <div :class="{ filtterItem: true, checkedRed: hasOrderStatusType }" @click.stop="poputShow(3)">
        {{ lang.OrderStatus }}
        <div :class="{ h: true, checkedBgRed: hasOrderStatusType }"></div>
      </div>
    </div>
    <div v-if="!showList" class="no-list">
      <img src="../assets/none_orders.png" alt />
      {{ lang.noPaymentHistory }}
    </div>
    <section class="detail-list">
      <van-list v-if="showList" v-model="loading" :finished="finished" :finished-text="lang.noMoreRecords" :loading-text="lang.loadingText" @load="loadOrdersList">
        <ul>
          <li v-for="(it, index) in ordersList" :key="index">
            <div class="detail-list-title">
              <p>
                <span class="span1">{{ it.itemWithCulture }}</span>
              </p>
              <!-- {{ !it.orderStatus ? lang.unPaid : it.orderStatus == 1 ? lang.paid : lang.close }} -->
              <p>
                <span style="padding-right: 16px; color: #ed1c24" v-if="!it.orderStatus">{{ lang.unPaid }}</span>
                <span style="padding-right: 16px; color: #4eb88c" v-if="it.orderStatus && it.orderStatus == 1">{{ lang.paid }}</span>
                <span style="padding-right: 16px; color: #999999" v-if="it.orderStatus && it.orderStatus !== 1">{{ lang.close }}</span>
              </p>
            </div>
            <div class="detail-list-content">
              <p>
                <span>{{ lang.t4 }}：</span>
                <span style="color: #333">{{ it.orderID }}</span>
              </p>
              <p>
                <span>{{ lang.t7 }}：</span>
                <span style="color: #333"
                  >{{ it.itemWithCulture }}<span v-if="it.sourceType === 'Property'" style="color: #333">，{{ it.sourceID }}</span></span
                >
              </p>
              <p>
                <!-- 1 已付款 2是 -->
                <span style="color: #333" v-if="it.orderStatus != 2 && it.orderStatus != 1">
                  <span style="color: #999">{{ lang.Remainingtime }}</span
                  >：{{ it.expireTime | exTime(it.expireTime, it.orderStatus) }}{{ lang.day }}</span
                >
              </p>
              <p class="price">
                <span>{{ lang.t8 }}：</span>
                <span v-if="it.paymentType">HK${{ it.money }}</span>
                <span v-else>{{ lang.gold }}{{ it.money }}</span>
              </p>
            </div>
            <div class="time-btn">
              <div class="time-box">{{ it.createTime | getTime2 }}</div>
              <div class="btn-box" v-if="!it.orderStatus">
                <span style="margin-right: 16px" @click="closeOrder(it)">{{ lang.CancelOrder }}</span>
                <span @click="gopay(it)">{{ lang.PayNow }}</span>
              </div>
            </div>
          </li>
        </ul>
      </van-list>
    </section>
    <!-- 全部分类筛选 -->
    <van-popup v-model="allClassifyShow" round position="bottom">
      <div v-if="!hasClassifyType" class="popup-item" style="color: #ed1c24" @click="searchList('all', 1)">{{ lang.allText }}</div>
      <div v-else class="popup-item" style="color: #333" @click="searchList('all', 1)">{{ lang.allText }}</div>
      <div class="popup-item" v-for="(item, index) in allClassifyList" :key="index" @click="searchList(item, 1)">
        <div :class="{ borderBottmNone: index === allClassifyList.length - 1, selectColr: hasClassifyType === item.dictionaryValue }">{{ item.dictionaryNameWithCulture }}</div>
      </div>
    </van-popup>
    <!-- 付款方式筛选 -->
    <van-popup v-model="payStyleShow" round position="bottom">
      <div v-if="!hasPayStyleType" class="popup-item" style="color: #ed1c24" @click="searchList('all', 2)">{{ lang.allText }}</div>
      <div v-else class="popup-item" style="color: #333" @click="searchList('all', 2)">{{ lang.allText }}</div>
      <div class="popup-item" v-for="(item, index) in payStyleList" :key="index" @click="searchList(item, 2)">
        <div :class="{ borderBottmNone: index === payStyleList.length - 1, selectColr: hasPayStyleType === item.dictionaryValue }">{{ item.dictionaryNameWithCulture }}</div>
      </div>
    </van-popup>
    <!-- 订单状态筛选 -->
    <van-popup v-model="orderStatusShow" round position="bottom">
      <div v-if="!hasOrderStatusType" class="popup-item" style="color: #ed1c24" @click="searchList('all', 3)">{{ lang.allText }}</div>
      <div v-else class="popup-item" style="color: #333" @click="searchList('all', 3)">{{ lang.allText }}</div>
      <div class="popup-item" v-for="(item, index) in orderStatusList" :key="index" @click="searchList(item, 3)">
        <div :class="{ borderBottmNone: index === orderStatusList.length - 1, selectColr: hasOrderStatusType === item.dictionaryValue }">{{ item.dictionaryNameWithCulture }}</div>
      </div>
    </van-popup>
    <van-popup v-model="popupPayStyle" round position="bottom" @close="closePayPoput">
      <div v-if="popupPayStyle" class="pay-popup">
        <div class="pay-popup-title">
          {{ lang.confirmPaid }}
          <img class="close-icon" src="../assets/closeIcon.png" alt="" @click="closePayPoput" />
        </div>
        <div class="money-style" v-if="value !== lang.columns[5]">HK${{ orderInfo.money }}</div>
        <div class="money-style" v-else>{{ lang.gold }}:{{ orderInfo.money }}</div>
        <div class="order-info">
          <div>{{ lang.orderInfo1 }}</div>
          <div style="color: #333333">{{ orderInfo.itemWithCulture }}</div>
        </div>
        <div class="pay-style">{{ lang.pdmeth }}</div>
        <div class="pdBox">
          <van-radio-group v-model="radio" @change="radioChange">
            <!-- <section>
              <ul>
                <li v-for="item in pay" :class="item.attr == 'trans' ? 'linetrans' : ''" :key="item.id">
                  <span>
                    <img :src="item.img" alt="" :class="item.attr == 'paypal' ? 'palimg' : ''" />
                    <span>{{ item.text }}</span>
                  </span>
                  <van-radio class="paycol" checked-color="#ED1818" :name="item.attr" v-model="radio"></van-radio>
                </li>
              </ul>
            </section> -->
            <div v-if="orderInfo.sourceType != 'PropertyCoin'" class="pdFlex" @click="changeRad(`${lang.columns[5]}`)">
              <div>
                <img style="width: 22px; height: 17px; margin-right: 12px" src="../assets/gold.png" alt="##" />
                <span class="coin-text">{{ lang.Coin }}</span>
              </div>
              <van-radio checked-color="#ED1818" :name="lang.columns[5]"></van-radio>
            </div>
            <div class="pdFlex" @click="changeRad(`${lang.columns[0]}`)">
              <div>
                <img style="width: 22px; height: 17px; margin-right: 12px" src="../assets/postCard.png" alt="##" />
                <span>{{ lang.pdCre }} (VISA, Mastercard)</span>
              </div>
              <van-radio checked-color="#ED1818" :name="lang.columns[0]"></van-radio>
            </div>
            <div class="pdFlex" @click="changeRad(`${lang.columns[1]}`)">
              <img style="width: 96px; height: 21px" src="../assets/pay01.png" alt="##" class="palimg" />
              <van-radio checked-color="#ED1818" :name="lang.columns[1]"></van-radio>
            </div>
            <!-- 支付宝支付 -->
            <div v-if="isAliPay" class="pdFlex" @click="changeRad(`${lang.columns[2]}`)">
              <div style="display: flex; align-items: center">
                <img src="../assets/alipay@2x.png" alt="##" class="palimg" style="width: 22px; height: 22px; margin-right: 12px" />
                <div class="ali-text">
                  <div>AlipayHK</div>
                  <div style="font-size: 12px; margin-top: 8px">({{ lang.alipayText }}）</div>
                </div>
              </div>
              <van-radio checked-color="#ED1818" :name="lang.columns[2]"></van-radio>
            </div>
            <!-- 微信支付 -->
            <div v-if="isWePay" class="pdFlex" @click="changeRad(`${lang.columns[3]}`)">
              <div style="display: flex; align-items: center">
                <img src="../assets/wechat@2x.png" alt="##" class="palimg" style="width: 22px; height: 22px; margin-right: 12px" />
                <div class="ali-text">
                  <div>WeChat Pay HK</div>
                  <div style="font-size: 12px; margin-top: 8px">({{ lang.wePayText }})</div>
                </div>
              </div>
              <van-radio checked-color="#ED1818" :name="lang.columns[3]"></van-radio>
            </div>
            <div class="pdFlex" @click="changeRad(`${lang.columns[4]}`)">
              <div style="display: flex; align-items: center">
                <img style="width: 22px; height: 22px; margin-right: 12px" src="../assets/banktran.png" alt="##" />
                <div>
                  <div>{{ lang.columns[4] }}</div>
                  <div style="font-size: 12px; margin-top: 8px">{{ lang.transferFake }}</div>
                </div>
              </div>
              <van-radio checked-color="#ED1818" :name="lang.columns[4]"></van-radio>
            </div>
          </van-radio-group>
        </div>
        <div class="pay-btn" @click="confirmPay">{{ lang.PayNow }}</div>
      </div>
    </van-popup>
    <van-dialog v-model="dialogShow" show-cancel-button :cancelButtonText="lang.cancelBtn" :confirmButtonText="lang.confirm" @confirm="close()">
      <div class="dialog-style">{{ lang.cancelOrders }}</div>
    </van-dialog>
  </div>
</template>

<script>
import pub from '../../common/public';
// import { Cell, NavBar, List } from 'vant';
import lang from './../../common/language/orders';
import { Dialog, Toast } from 'vant';
export default {
  name: 'orders',
  data() {
    return {
      allClassifyShow: false, // 全部分类筛选弹窗控制器
      payStyleShow: false, // 付款方式筛选弹窗控制器
      orderStatusShow: false, // 订单状态筛选弹窗控制器
      fixedFlag: false,
      checkedType: 0,
      hasClassifyType: '',
      hasPayStyleType: '',
      hasOrderStatusType: '',
      radio: lang.columns[0],
      value: 'paydollar',
      popupPayStyle: false,
      dialogShow: false,
      isPc: false,
      count: 0,
      lang: lang,
      show: true,
      currentPage: 1,
      ordersList: [],
      loading: false,
      finished: false,
      showList: true,
      allClassifyList: [],
      payStyleList: [],
      orderStatusList: [],
      OrderItem: [],
      OrderStatus: [],
      orderData: null,
      orderInfo: {},
      OrderPaymentType: [],
      checkedFlag: 0,
      isAliPay: true, //支付宝的支付开关
      isWePay: true, // 微信的支付开关
    };
  },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    const ua = navigator.userAgent.toLowerCase();
    const platform = ua.indexOf('house730') > -1 ? 'app' : '';
    if (platform == 'app') {
      const sys = ua.indexOf('iphone') > -1 || ua.indexOf('ios') > -1 ? 'ios' : 'android';
      if (sys == 'ios') {
        this.isAliPay = true;
        this.isWePay = false;
      } else {
        this.isAliPay = true;
        this.isWePay = false;
      }
    } else {
      this.isAliPay = true;
      this.isWePay = false;
    }
    // /**获取用户信息 */
    // this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
    //   if (res.data.code == 0 && res.data.result) {
    //     this.userInfo = res.data.result;
    //   }
    // });
    this.SearchDictionaryInfo();
  },
  // 格式化过期时间
  filters: {
    exTime(orderStatus, time) {
      if (orderStatus == 2 || orderStatus == 1) return;
      // 1.获取当前时间
      let nowDate = Math.round(new Date().getTime() / 1000);
      // 未过期订单
      if (time > nowDate) {
        let hours = (time - nowDate) / 60 / 60 / 24;
        let intHour = parseInt(hours);
        // 规则：不足一天展示一天,1.2天 展示2天
        if (hours > intHour) {
          intHour += 1;
        }
        return intHour;
      }
    },
  },
  mounted() {
    // 监听滚轮事件
    window.addEventListener('scroll', this.handleScroll);
  },
  // components: {
  //   [Cell.name]: Cell,
  //   [NavBar.name]: NavBar,
  //   [List.name]: List
  // },
  methods: {
    closePayPoput() {
      this.popupPayStyle = false;
      this.radio = 'paydollar';
      this.value = 'paydollar';
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let offsetTop = document.querySelector('.filtter-box').offsetTop;
      let offsetMainTop = document.querySelector('.detail-list').offsetTop;
      this.fixedFlag = scrollTop >= offsetTop;
      if (offsetMainTop - scrollTop >= 40) {
        this.fixedFlag = false;
      }
      if (offsetMainTop - scrollTop <= 40) {
        document.querySelector('.detail-list').style.zIndex = 1;
      } else {
        document.querySelector('.detail-list').style.zIndex = 999;
      }
    },
    changeRad(payradio) {
      this.radio = payradio;
    },
    radioChange() {
      this.value = this.radio;
    },
    onClickLeft() {
      // this.$router.go(-1);
      this.$router.push('/');
    },
    // 获取数据字典
    SearchDictionaryInfo() {
      this.axios.get(this.pub.getApi().SearchDictionaryInfo).then((res) => {
        if (res.data.code == 0 && res.data.result) {
          res.data.result.forEach((item) => {
            if (item.itemName === 'OrderItem') {
              this.OrderItem = item.children;
            }
            if (item.itemName === 'OrderStatus') {
              this.OrderStatus = item.children;
            }
            if (item.itemName === 'OrderPaymentTypeForWeb') {
              this.OrderPaymentType = item.children;
            }
          });
        }
      });
    },
    loadOrdersList() {
      let data = {};
      data = {
        orderStatus: this.hasOrderStatusType ? this.hasOrderStatusType : null,
        PaymentTypeList: this.hasPayStyleType ? [this.hasPayStyleType] : null,
        orderItem: this.hasClassifyType ? this.hasClassifyType : null,
        pageIndex: this.currentPage,
        pageCount: 10,
      };
      this.axios.post(this.pub.getApi().SearchOrderRecord, data).then((res) => {
        if (res.data.code == 0 && res.data.result) {
          this.count = res.data.result.count;
          this.ordersList = this.ordersList.concat(res.data.result.data);
          if (this.ordersList.length === 0) {
            this.showList = false;
          }
          this.currentPage++;
          this.loading = false;
          if (this.ordersList.length >= this.count) {
            this.finished = true;
          }
        }
      });
    },
    gopay(data) {

      this.axios.get(this.pub.getApi().VerifyPropertyCanRenewal, {
        params: {
          propertyId: data.sourceID
        }
      }).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          if (res.data.result) {
            // 立即付款 type = 1
            this.orderInfo = data;
            this.popupPayStyle = true;
          } else {
            Dialog.confirm({
              title: '',
              message: lang.parNowText,
              confirmButtonText: lang.confirmBtn,
              cancelButtonText: lang.cancelBtn
            })
            .then(() => {
            })
            .catch(() => {
            });
          }
        }
      })
      // this.poputShow(2);
      // this.$router.push(`/pay?orderid=${data.orderID}`);
    },
    poputShow(type) {
      this.checkedType = type;
      if (type === 1) {
        this.allClassifyShow = true;
        this.allClassifyList = this.OrderItem;
      } else if (type === 2) {
        this.payStyleShow = true;
        this.payStyleList = this.OrderPaymentType;
      } else if (type === 3) {
        this.orderStatusShow = true;
        this.orderStatusList = this.OrderStatus;
      }
    },
    // 筛选查询
    searchList(data, type) {
      this.checkedFlag = this.checkedType;
      console.log(data);
      if (type === 1) {
        this.allClassifyShow = false;
        this.hasClassifyType = data === 'all' ? null : data.dictionaryValue;
      } else if (type === 2) {
        console.log(data);
        this.payStyleShow = false;
        this.hasPayStyleType = data === 'all' ? null : data.dictionaryValue;
      } else {
        this.orderStatusShow = false;
        this.hasOrderStatusType = data === 'all' ? null : data.dictionaryValue;
      }
      this.showList = true;
      this.currentPage = 1;
      this.ordersList = [];
      this.finished = false;
      this.loading = true;
      this.loadOrdersList();
    },
    // 关闭订单
    closeOrder(data) {
      this.dialogShow = true;
      this.cancelOrderId = data.orderID;
    },
    close() {
      this.axios.get(this.pub.getApi().CloseOrder + `?orderId=${this.cancelOrderId}`).then((res) => {
        if (res.data.code == 0 && res.data.result) {
          location.reload();
        }
      });
    },
    confirmPay() {
      const fromapp = this.$route.query.fromapp;
      if (this.value === this.lang.columns[1]) {
        this.$router.push(`/pay?orderid=${this.orderInfo.orderID}&type=paypal${fromapp ? '&fromapp=' + fromapp : ''}&source=orders${this.post ? '&form=post' : ''}`);
      } else if (this.value === this.lang.columns[0]) {
        this.$router.push(`/pay?orderid=${this.orderInfo.orderID}&type=paydollar${fromapp ? '&fromapp=' + fromapp : ''}&source=orders${this.post ? '&form=post' : ''}`);
      } else if (this.value === this.lang.columns[2]) {
        this.$router.push(`/pay?orderid=${this.orderInfo.orderID}&type=lpay${fromapp ? '&fromapp=' + fromapp : ''}&source=orders${this.post ? '&form=post' : ''}`);
      } else if (this.value === this.lang.columns[3]) {
        this.$router.push(`/pay?orderid=${this.orderInfo.orderID}&type=wpay${fromapp ? '&fromapp=' + fromapp : ''}&source=orders${this.post ? '&form=post' : ''}`);
      } else if (this.value === this.lang.columns[4]) {
        this.$router.push(`/pay?orderid=${this.orderInfo.orderID}&type=transfer${fromapp ? '&fromapp=' + fromapp : ''}&soure=orders${this.post ? '&form=post' : ''}`);
      } else {
        this.axios
          .post(this.pub.getApi().PropertyCoinPaymentOrder, {
            orderId: this.orderInfo.orderID,
          })
          .then((result) => {
            /*屋币不足*/
            if (result.data.code == 1707) {
              this.popupPayStyle = false;
              return Dialog.confirm({
                title: lang.noGold,
                message: lang.noGoldText,
                confirmButtonText: lang.addGold,
                cancelButtonText: lang.cancelBtn,
              })
                .then(() => {
                  this.$router.push({ name: 'storedValueMoney', query: { from: 'orders', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
                })
                .catch(() => {
                  this.$router.push({ name: 'orders', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
                });
            }
            //付款成功
            if (result.data.code === 0 && result.data.result) {
              let tips = '';
              // if (this.info.topType == 3 || this.info.topType.startsWith('Star')) {
              //   tips = lang.payDone + '\n' + lang.payDownStar;
              // } else {

              // }
              tips = lang.payDone;
              Dialog.alert({
                title: lang.thanks,
                message: tips,
                confirmButtonText: this.lang.confirm,
                cancelButtonText: this.lang.cancel,
              });
              setTimeout(() => {
                this.$router.push({ name: 'orders', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
              }, 500);
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
.van-nav-bar__text {
  color: #ed1c24;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  margin: 0;
  width: 100%;
  height: 100%;
  margin: 0;
}
.filtter-box {
  position: relative;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  width: 100%;
  height: 44px;
  background: #fafbfc;
  box-shadow: inset 0 -1px 0 0 rgba(167, 167, 167, 0.5);
  .filtterItem {
    display: flex;
    align-items: center;
  }
}
.orders {
  /deep/ .van-list__finished-text {
    background-color: #f5f6f7;
  }
  .van-list {
    background-color: #f5f6f7;
  }
  width: 100%;
  height: 100%;
  background-color: #f5f6f7;
  text-align: left;
  .no-list {
    margin-top: 150px;
    text-align: center;
    font-size: 15px;
    img {
      margin: 0 auto;
      display: block;
      height: 120px;
      width: 120px;
    }
  }
  .detail-list {
    margin-top: 14px;
    ul {
      background-color: #f5f6f7;
      li {
        padding-left: 15px;
        // height: 105px;
        background-color: #fff;
        margin-bottom: 10px;
        .detail-list-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;
          height: 32px;
          border-bottom: 1px solid #eee;
          p {
            margin: 0;
            line-height: 32px;
            font-size: 12px;
            font-weight: 700;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .span1 {
              font-family: PingFangSC-Semibold;
              font-weight: bold;
              font-size: 12px;
              color: #333333;
            }
            span {
              padding-right: 6px;
              font-size: 10px;
              font-weight: normal;
            }
          }
        }
        .detail-list-content {
          // height: 72px;
          border-bottom: 1px solid #eee;
          padding-top: 8px;
          box-sizing: border-box;
          p {
            margin: 0;
            font-size: 12px;
            color: #333;
            line-height: 20px;
            span {
              color: #999;
            }
          }
          .price {
            margin-top: 8px;
            padding-bottom: 10px;
          }
          .price span {
            font-family: PingFangSC-Medium;
            font-weight: bold;
            font-size: 14px;
            color: #0054a6;
          }
        }
        .time-btn {
          padding-right: 16px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .time-box {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
          .btn-box {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #0076ff;
          }
        }
      }
    }
  }
  .no-order-list {
    font-size: 14px;
    color: #333;
    text-align: center;
  }
}
.h {
  width: 0px;
  height: 0px;
  border: 5px solid transparent;
  border-top-color: #333333;
  margin-top: 6px;
  margin-left: 5px;
}
.popup-item {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  border-bottom: 1px solid #eeeeee;
}
.borderBottmNone {
  border-bottom: none;
}
.dialog-style {
  padding: 48px;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.pay-popup {
  padding: 16px;
  .pay-popup-title {
    font-family: PingFangSC-Medium;
    font-weight: bold;
    font-size: 16px;
    color: #171725;
    position: relative;
    height: 41px;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    .close-icon {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .money-style {
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-weight: bold;
    font-size: 40px;
    color: #171725;
    margin: 24px 0;
  }
  .order-info {
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #eeeeee;
  }
  .pay-style {
    height: 50px;
    text-align: left;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
  }
  .pdBox {
    .pdFlex {
      font-size: 14px;
      color: #333333;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid #ededed;
      height: 53px;
      align-items: center;
      // line-height: 50px;
      img {
        margin: 0 4px -5px 0;
      }
      .palimg {
        // margin-top: 18px;
        height: 16px;
      }
      /deep/.van-radio__icon .van-icon {
        height: 16px;
        width: 16px;
        border: 1px solid #979797;
      }
      /deep/.van-radio__icon,
      .van-radio__label {
        line-height: 17px;
      }
    }
  }
  .pay-btn {
    text-align: center;
    line-height: 44px;
    height: 44px;
    background: #ed1c24;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    margin-top: 16px;
  }
}
.selectColr {
  color: #ed1c24;
}
.checkedRed {
  color: #ed1c24;
}
.checkedBgRed {
  width: 0px;
  height: 0px;
  border: 5px solid transparent;
  border-top-color: #ed1c24;
  margin-top: 6px;
  margin-left: 5px;
}
.list-tab-fixed {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 1;
  // height: 1rem;
  border-radius: 0;
}
.coin-text {
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(to right, #6f5118, #a3852f);
  -webkit-background-clip: text;
  color: transparent;
}
</style>
